export const uk = {
    "n1": "Домашня сторінка",
    "n2": "порядок",
    "n3": "угода",
    "n4": "команда",
    "n5": "моя",
    "t1": "щось пішло не так",
    "t2": "Успішно скопійовано",
    "t3": "Будь ласка, заповніть інформацію повністю",
    "t4": "Завантаження…",
    "t5": "Вхід успішний",
    "t6": "Для надсилання оцінка має бути більше 3",
    "t7": "Надіслано успішно",
    "t8": "Недостатній баланс, неможливо отримати",
    "t9": "Не вдалося подати",
    "t10": "Спочатку прив’яжіть адресу, і ви будете перенаправлені на сторінку персонального центру.",
    "t11": "Адресу прив’язано, будь ласка, зверніться до служби підтримки, щоб змінити її.",
    "t12": "Зміна успішна",
    "t13": "Не вдалося внести зміни",
    "t14": "Щоб змінити пароль, зверніться до служби підтримки клієнтів",
    "t15": "Помилка формату пароля",
    "t16": "Вилучити успішно",
    "t17": "Максимальна сума, яку можна зняти",
    "t18": "Мінімальне виведення",
    "t19": "Два паролі не відповідають один одному",
    "t20": "Поради",
    "t21": "На даний момент неможливо стрибнути",
    "t22": "Помилка формату пароля",
    "t23": "Реєстрація успішна",
    "t24": "Будь ласка, введіть код міста",
    "t25": "Не більше",
    "l1": "Мова",
    "l2": "Будь ласка, введіть номер рахунку",
    "l3": "Будь ласка, введіть пароль",
    "l4": "запам'ятати",
    "l5": "Логін",
    "l6": "Перейти до реєстрації",
    "l7": "Немає облікового запису",
    "l8": "Номер мобільного телефону",
    "l9": "псевдонім",
    "l10": "Пароль",
    "l11": "Підтвердьте пароль",
    "l12": "Код запрошення",
    "l13": "зареєструватися",
    "l14": "Вже є акаунт",
    "l15": "Перейти до входу",
    "l16": "Введіть пароль із 6-16 цифр",
    "bz1": "допомогти",
    "bz2": "FAQ",
    "bz3": "правила торгівлі",
    "bz4": "Як вивести гроші",
    "bz5": "Як зарядити",
    "bz6": "1. Що таке Amazon Review RoBoT?",
    "bz7": "Amazon Review RoBoT – це компанія з маркетингового просування, яка допомагає торговцям онлайн-магазинів Amazon Review RoBoT у всьому світі отримувати більше замовлень і збільшувати дані веб-перегляду онлайн-магазинів Amazon Review RoBoT. Ми прагнемо створити тристоронню модель прибуткового маркетингу та просування між Amazon Review RoBoT, продавцями та споживачами. У поєднанні з новітньою технологією блокчейну P2P споживачі та торговці швидко з’єднуються через USDT (TRC20, ERC20). Зареєстровані користувачі можуть отримувати комісійні за замовлення, а торговці можуть збільшити дані про продажі свого магазину. Це найновіша модель прибутку в моделі інтернет-блокчейну!",
    "bz8": "2. Як працює Amazon Review RoBoT?",
    "bz9": "Щоденний відгук від Amazon Review RoBoT показує, що продукти, які потребують вдосконалення, продаються в Amazon Review RoBoT. Користувачам потрібно лише легко натиснути на замовлення, і система автоматично генерує підписку на замовлення. Користувачі оплачують суму замовлення через блокчейн USDT і отримують щоденну комісію.",
    "bz10": "3. Чому ціни однієї і тієї ж валюти відрізняються у двох угодах?",
    "bz11": "Цінові відмінності викликані всіма факторами, які не сприяють вільному обігу валют, включаючи швидкість переказів валюти, умови мережі, обмеження доступу до валюти, визнання валюти людьми в різних регіонах і навіть типи торгових пар, які пропонуються біржами, транзакціями тощо. Тому одна і та ж валюта може мати різницю в ціні в різних транзакціях.",
    "bz12": "4. Інвестиційний прибуток?",
    "bz13": "Чим вища ціна товару, тим більший прибуток ви отримуєте від замовлення. У той же час Amazon Review RoBoT випадковим чином розподіляє великі комісійні замовлення.",
    "bz14": "Щодня система автоматично генерує та розповсюджує користувачам 60 замовлень товарів. Користувачі здійснюють платіж за кожне замовлення через USDT і отримують 0,6% комісії. Великі комісійні замовлення призначаються випадковим чином.",
    "bz15": "USDT можна зняти після 60 замовлень. (Якщо 60 замовлень не виконано, система автоматично зупиниться до тих пір, поки не буде виконано решту замовлень дня)",
    "bz16": "Кожен обліковий запис може бути прив’язаний лише до одного облікового запису USDT. У разі виникнення помилки зверніться до служби підтримки клієнтів.",
    "bz17": "Після завершення доставки щоденних замовлень ви можете зняти гроші в звичайному режимі. Гроші надійдуть протягом 24 годин після початку виведення, ліміту на виведення немає.",
    "bz18": "Перш ніж поповнювати рахунок, прив’яжіть свою адресу для виведення (підтримує TRC-20) до адреси USDT. Ви можете натиснути на поповнення в APP або на веб-сторінці та вибрати блокчейн (TRC-20), який ви використовуєте для поповнення.",
    "bz19": "Взаємне поповнення чи взаємний переказ між пов’язаними рахунками не дозволяється. Це зловмисне захоплення замовлень і серйозно впливає на правила роботи платформи. Якщо така поведінка виявлена, система негайно заморозить обліковий запис і дискваліфікує роботу.",
    "ty1": "добре",
    "ty2": "Скасувати",
    "ty3": "Надіслати",
    "ty4": "Адреса TRC20",
    "ty5": "адреса ERC20",
    "s1": "Сукупний дохід",
    "s2": "обслуговування",
    "s3": "Про нас",
    "s4": "допомогти",
    "s5": "Партнери",
    "s6": "мої послуги",
    "d1": "Не завершено",
    "d2": "Виконано",
    "d3": "Даних ще немає",
    "d4": "Номер замовлення",
    "d5": "години торгівлі",
    "d6": "Сума",
    "d7": "Поточна кількість завдань",
    "d8": "очікуваний прибуток",
    "d9": "Ще потрібно",
    "d10": "Рейтинг",
    "j1": "Баланс на рахунку",
    "j2": "Введення в торгівлю",
    "j3": "Amazon Review RoBoT щодня використовує відгуки Amazon Review RoBoT, щоб продемонструвати продукти, продані Amazon Review RoBoT, які потребують вдосконалення. Користувачам потрібно лише натиснути на замовлення, і система автоматично згенерує підпис замовлення. Користувачі оплачують суму замовлення через блокчейн USDT і можуть щоразу отримувати більше 0,6% комісії, а система випадковим чином розподіляє великі винагородні замовлення.",
    "j4": "Почніть зіставляти",
    "j5": "Сьогоднішній заробіток",
    "j6": "Виконано",
    "j7": "Загальна кількість завдань",
    "td1": "баланс",
    "td2": "Комісія",
    "td3": "отримати",
    "td4": "загальна кількість людей",
    "td5": "Користувач",
    "td6": "Внести свій внесок",
    "td7": "Кількість",
    "td8": "Статус",
    "g1": "Зняти готівку",
    "g2": "Перезарядка",
    "g3": "Запрошуйте друзів",
    "g4": "Запросіть зараз",
    "g5": "За кожен прибуток, отриманий вашими друзями після реєстрації, ви отримаєте відповідну комісію.",
    "g6": "особиста інформація",
    "g7": "Реквізити фонду",
    "g8": "Запис поповнення",
    "g9": "Записи про вилучення",
    "g10": "Мова",
    "g11": "Вийти",
    "g12": "Ви впевнені, що бажаєте вийти?",
    "yh1": "Інформація про користувача",
    "yh2": "Змінити",
    "yh3": "налаштування",
    "yh4": "телефон",
    "yh6": "Оригінальний пароль",
    "yh7": "новий пароль",
    "mx1": "Комісійний збір",
    "mx2": "дохід",
    "mx3": "Вилучення відхилено",
    "mx4": "час",
    "mx5": "Перезарядка успішна",
    "mx6": "Відхилено",
    "mx7": "В очікуванні",
    "mx8": "Адреса вилучення",
    "mx9": "наявний залишок",
    "mx10": "Фактичне прибуття",
    "mx11": "Будь ласка, введіть суму зняття",
    "cz1": "Адреса депозиту підтримує лише ERC20, а мінімальна сума депозиту становить 20 USDT.",
    "cz2": "Копія",
    "cz3": "Вибір фіатної валюти",
    "cz4": "платити",
    "cz5": "Адреса депозиту підтримує лише TRC20-USDT, а мінімальна сума депозиту становить 20 USDT.",
    "cz6": "Адреса депозиту підтримує лише ERC20, а мінімальна сума депозиту становить 20 USDT.",
    "qy1": "код регіону",
    "yq1": "Запрошуйте друзів",
    "yq2": "Код запрошення",
    "yq3": "Запрошуйте друзів і отримуйте величезні переваги",
    "yq4": "Ідіть і запросіть",
    "zf1": "Спосіб поповнення",
    "zf2": "Виберіть спосіб поповнення рахунку",
    "zf3": "торгівля валютами",
    "zf4": "торгова мережа",
    "zf5": "Іди торгувати",
    "zf6": "Успішно скопійовано",
    "zf7": "торгівля валютами",
    "zf8": "Будь ласка, використовуйте",
    "zf9": "Перекажіть гроші на вказану нижче адресу, щоб завершити поповнення.",
    "zf10": "Валюта транзакції",
    "zf11": "Копія",
    "zf12": "Уважно перевірте адресу. Якщо ви передасте його неправильно, ви не зможете його відновити.",
    "zf13": "Час прибуття",
    "zf14": "Приблизно 1~5 хвилин",
    "zf15": "Мінімальна сума поповнення",
    "a1": "Центр маркетингу магазину",
    "a2": "Маркетинговий центр магазину Amazon Market Robot — це абсолютно новий розділ, розроблений для того, щоб допомогти торговцям швидко збільшити продажі та оцінку своїх товарів за короткий проміжок часу, тим самим збільшуючи вагу продуктів і ще більше збільшуючи їх показ; користувачі допомагають торговцям, виконуючи різноманітні завдання та отримуючи відповідні винагороди, таким чином досягаючи ситуації, в якій обидві сторони виграють.",
    "a3": "На даний момент система має 30 мільйонів користувачів і 5 мільйонів продавців, а кількість товарів, що просуваються на платформі щодня, досягає 70 мільйонів; деякі торгові продукти збільшили продажі в магазині на 60% завдяки підключенню до системи маркетингового центру; а користувачам платформи системи маркетингового центру потрібно лише натиснути на замовлення, і система маркетингового центру автоматично згенерує підпис замовлення. Після передоплати користувачем суми замовлення віртуальна транзакція завершується, а кошти негайно повертаються на обліковий запис користувача. Кожен раз можна отримати додаткову комісію більше 0,6%. Система також буде випадковим чином розподіляти великі замовлення на винагороду, щоб збільшити комісію користувача.",
    "a4": "Amazon Market Robot надає великого значення потребам користувачів і торговців і продовжує оптимізувати та вдосконалювати систему маркетингового центру.",
    // 客服
    "kf1": "Онлайн-підтримка клієнтів",
    "kf2": "Ручний вивід через підтримку",
    "kf3": "Ви можете натиснути тут, щоб зв'язатися з ручною підтримкою для виведення коштів",
    "kf4": "Ручне поповнення через підтримку",
    "kf5": "Ви можете натиснути тут, щоб зв'язатися з ручною підтримкою для поповнення",
    // 支付选项弹窗
    "zf16": "Для транзакцій за банківською карткою зверніться до служби підтримки",
    "zf17": "Зв'язатися зі службою підтримки"
  }
  